import { QrCodeCustomizer } from '@/features/qr-code/components/QrCodeCustomizer';
import { PwaStatus } from '@/features/pwa/PwaStatus';

import { ThemeToggle } from './ThemeToggle';

export function App() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="border-b bg-card">
        <div className="container mx-auto flex flex-wrap items-center justify-between gap-4 px-4 py-5">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">QR Code Customizer</h1>
            <p className="text-sm text-muted-foreground">
              Personalisierte QR-Codes mit eigenem Logo, Farben und Formen
            </p>
          </div>
          <div className="flex items-center gap-2">
            <PwaStatus />
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="container mx-auto flex-1 px-4 py-8">
        <QrCodeCustomizer />
      </main>

      <footer className="border-t bg-muted/40">
        <div className="container mx-auto px-4 py-6 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} QR Code Customizer
        </div>
      </footer>
    </div>
  );
}
